import React, {useEffect, useState} from "react";
import HelperService from "../../services/helper-service";
import {AttachmentTypes} from "../../utils/constants";
import helperService from "../../services/helper-service";

export default function ArticleCell({ article, edit, del, onSuccess, className, ...props}) {
  const [cover, setCover] = useState(null);

  useEffect(()=>{
    if (article){
      let ci = HelperService.getObjByKey(article.attachments, 'attachment_type_id', AttachmentTypes.cover.val);
      setCover(ci ? ci : null);

    } else {
      setCover(null);
    }
  }, [article]);

  return (
    <>
      <div className={"d-flex justify-content-between align-items-center bg-light-lighten p-2 rounded gap-2 mb-2 "+className}>
        <div className={"d-flex justify-content-start align-items-center"}>
          <div>
            {cover && <img src={cover?.thumbUrl} className="rounded rounded-2 me-2" width="50" alt="" />}
          </div>
          <div>
            <div>
              <strong>{article.title}</strong>
            </div>
            <div>
            <span className="me-2">
              {article?.is_published && <><span className="mdi mdi-send"></span> Publikované</>}
              {!article?.is_published && <><span className="mdi mdi-send"></span> Draft</>}
            </span>
              <span className="me-2">
                <span className="mdi mdi-clock-outline me-1"></span>{helperService.formatDateTime(article.created_at)}
            </span>
            </div>
          </div>
        </div>

        {(edit||del) && <div className={"d-inline-flex"}>
          {edit && <button type="button" className="btn btn-sm btn-circle btn-light hover-text-primary ms-1" onClick={()=>edit(article)}><span className="mdi mdi-pencil" title="Upraviť"></span></button>}
          {del && <button type="button" className="btn btn-sm btn-circle btn-light hover-text-danger ms-1" onClick={()=>del(article)}><span className="mdi mdi-trash-can" title="Zmazať"></span></button>}
        </div>}
      </div>
    </>
  );
}
